import { api } from '../app/applicationSlice'
import { API_PREFIX } from './constant'
import { Request } from './request'

export interface PeddingMedicalTreatmentParams {
  current?: any
  size?: any
  state?: any
  endTime?: any
  startTime?: any
  keyword?: any
  registrationId?: any
  treatmentServiceId?: any
}

export function PeddingMedicalTreatmentList(params: PeddingMedicalTreatmentParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/medicalstation/page`,
    method: 'GET',
    params,
  }
}

// 获取项目列表
export interface XMPageListParams {
  endTime?: any
  startTime?: any
}

export function XMPageList(params: XMPageListParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/medicalstation/getTimeFrameTreatmentList`,
    method: 'GET',
    params,
  }
}

export function PeddingMedicalTreatmentDetail(params: PeddingMedicalTreatmentParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/medicalstation/getMedicalStationByRegistrationId`,
    method: 'GET',
    params,
  }
}

// 查询单个多个执行详情
export interface PeddingMedicalTreatmentRecordDetailParams {
  recipeId?: any
  recipeItemId?: any
}
export function PeddingMedicalTreatmentRecordDetail(params: PeddingMedicalTreatmentRecordDetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/medicalstation/detailsByRecipeId`,
    method: 'GET',
    params,
  }
}

export interface BatchExecuteDetailParams {
  attachmentFile?: any
  executeNum?: any
  executeTime?: any
  executeEndTime?: any
  treatmentParts?: any
  id?: any
  smsFlag?: any
  operatorName?: any
  operatorId?: any
  remark?: any
}
export function BatchExecuteDetail(body: BatchExecuteDetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/medicalstation/batchExecute`,
    method: 'POST',
    body,
  }
}



